import {
  dataValueFromStoreSetting
} from "@/services/ceSettings/ceSettingsService";
import { StoreSetting } from "@/types/ceSettings/ceSettings";

export default function useStrSpaceX(spaceX?: StoreSetting, fallback?: any) {
  return dataValueFromStoreSetting(spaceX, fallback)?.spaceX;
}
